import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { getLocalLanguage,  } from '@/utils/index'
import service from '@/utils/request'
import { setLocalStorage } from "@/utils/storage";

Vue.use(VueI18n)

export const defaultLang = getLocalLanguage('')

const messages = {
  'zh_CN': {},
}

const i18n = new VueI18n({
  locale: defaultLang,
  fallbackLocale: defaultLang,
  messages,
  silentTranslationWarn: true, // 去除国际化警告
})

export default i18n

export function setI18nLanguage(lang: any) {
  setLocalStorage('lang',  getLocalLanguage(lang))
  i18n.locale = lang
  service.defaults.headers.common['Accept-Language'] = lang
  const temp = document.querySelector('html') as any;
  temp.setAttribute('lang', lang)
  return lang
}
